import { render, staticRenderFns } from "./BillingInfo.vue?vue&type=template&id=05165a3a&"
import script from "./BillingInfo.vue?vue&type=script&lang=js&"
export * from "./BillingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports